// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IitP","option":"styles_option__3yIfc","selected":"styles_selected__31bwq"};